import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e77443c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-xia" }, null, -1))
const _hoisted_3 = { class: "com-nav" }
const _hoisted_4 = {
  key: 1,
  class: "warning-date-box"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-rili" }, null, -1))

import { ref, onActivated, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import type { CalendarInstance } from 'vant'
import { useStore } from 'vuex'

import Warning from './components/warning.vue'
import Monitor from './components/monitor.vue'
import DataBoard from '@/components/DataBoard/index.vue'
import DataTable from '@/components/DataTable/index.vue'
import ComHeader from '@/components/ComHeader/index.vue'
import ComVideo from '@/components/ComVideo/index.vue'
import { getShops, getStoreData } from '@/api/shop'
import { IShop, IBusiness, IDevice } from '@/utils/interface'
import { getValueBykey, formatTime } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const show = ref(false)
const startTime = ref('')
const endTime = ref('')
const refreshing = ref(false)
const dateTitle = ref('')
const business = ref<IBusiness[]>([])
const calendarRef = ref<CalendarInstance | null>()
const formatDate = (date: Date) =>
  `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
const onConfirmDate = (values: Date[]) => {
  const [start, end] = values
  show.value = false
  startTime.value = formatTime(start.getTime(), 'date')
  endTime.value = formatTime(end.getTime(), 'date')
  dateTitle.value = `${formatDate(start)} - ${formatDate(end)}`
  refreshing.value = true
  if (curIndex.value === 3) {
    getData()
  }
}

const data = ref<any>({})
const curIndex = ref<number>(2)
const changeNav = (index: number) => {
  startTime.value = ''
  endTime.value = ''
  dateTitle.value = ''
  if (index === 3) {
    getData(index)
  } else {
    curIndex.value = index
  }
  if (curIndex.value === 1 || curIndex.value === 3) {
    nextTick(() => {
      setTimeout(() => {
        // eslint-disable-next-line @typescript-eslint/no-extra-semi
        ;(calendarRef.value as CalendarInstance).reset()
      }, 100)
    })
  }
}

const calendarOpen = () => {
  if (!startTime.value) {
    nextTick(() => {
      const cal = calendarRef.value as any
      const dom = document.querySelector('.van-calendar__body') as any
      console.log('cal~~', cal)
      const back = dom.scrollTop
      setTimeout(() => {
        dom.scrollTop = back - 5
        console.log('start', back - 5)
      }, 10)
      setTimeout(() => {
        dom.scrollTop = back
        console.log('end', back)
        cal.scrollToDate(new Date())
      }, 100)
    })
  }
}

const getData = (index?: number) => {
  getStoreData({
    storeNo: result.value,
    startTime: startTime.value,
    endTime: endTime.value
  }).then((res) => {
    data.value = res
    index && (curIndex.value = index)
  })
}

const columns = ref<IShop[]>([])
const result = ref('')
const showPicker = ref(false)

const onConfirm = (value: IShop): void => {
  result.value = value.storeNo
  showPicker.value = false
  if (curIndex.value === 3) {
    getData()
  } else if (curIndex.value === 4) {
    // getBusiness()
  }
}

const route = useRoute()
const init = () => {
  result.value = route.params.id as string
  getShops().then((res: any) => {
    columns.value = res.storeList
  })
}
init()

// const getBusiness = (index?: number) => {
//   getBusinessData({
//     companyId: '1',
//     timeType: 0,
//     pageSize: 300,
//     page: 1,
//     shopNo: result.value
//   }).then((res: any) => {
//     business.value = res
//     index && (curIndex.value = index)
//   })
// }

const device = ref()
const isPlay = ref(false)
const handleMonitor = (data: IDevice, flag?: boolean) => {
  device.value = data
  flag && (isPlay.value = flag)
}

const isInit = ref(true)
onActivated(() => {
  if (!route.meta.isBack && !isInit.value) {
    device.value = null
    curIndex.value = -1
    result.value = ''
    dateTitle.value = ''
    startTime.value = ''
    endTime.value = ''
    setTimeout(() => {
      curIndex.value = 2
    }, 500)
    init()
  }
  isInit.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_calendar = _resolveComponent("van-calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ComHeader, {
      height: 16,
      title: ''
    }, {
      custom: _withCtx(() => [
        _createElementVNode("h1", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showPicker.value = true)),
          class: "custom-title"
        }, [
          _createTextVNode(_toDisplayString(_unref(getValueBykey)('storeNo', result.value, columns.value, 'storeName')), 1),
          _hoisted_2
        ]),
        _createVNode(_component_van_popup, {
          show: showPicker.value,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((showPicker).value = $event)),
          round: "",
          position: "bottom"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_picker, {
              columns: columns.value,
              "columns-field-names": { text: 'storeName' },
              onCancel: _cache[1] || (_cache[1] = ($event: any) => (showPicker.value = false)),
              onConfirm: onConfirm
            }, null, 8, ["columns"])
          ]),
          _: 1
        }, 8, ["show"])
      ]),
      icon: _withCtx(() => [
        _createVNode(_component_router_link, {
          tag: "i",
          to: "/shop",
          class: "iconfont icon-dianpu"
        })
      ]),
      _: 1
    }),
    (device.value && _unref(store).getters.tenantType !== 'daHua')
      ? (_openBlock(), _createBlock(ComVideo, {
          key: 0,
          imageUrl: require('../../../assets/images/v2_r5hikb.png'),
          videoUrl: device.value.videoUrl,
          isPlay: isPlay.value,
          onPause: _cache[3] || (_cache[3] = ($event: any) => (isPlay.value = false))
        }, null, 8, ["imageUrl", "videoUrl", "isPlay"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (changeNav(1))),
        class: _normalizeClass({ actived: curIndex.value === 1 })
      }, "预警信息", 2),
      _createElementVNode("a", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (changeNav(2))),
        class: _normalizeClass({ actived: curIndex.value === 2 })
      }, "监控直播", 2),
      _createElementVNode("a", {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (changeNav(3))),
        class: _normalizeClass({ actived: curIndex.value === 3 })
      }, "数据看板", 2),
      (_unref(store).getters.isHdl)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            onClick: _cache[7] || (_cache[7] = ($event: any) => (changeNav(4))),
            class: _normalizeClass({ actived: curIndex.value === 4 })
          }, "门店运营", 2))
        : _createCommentVNode("", true)
    ]),
    (curIndex.value === 1 || curIndex.value === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_van_field, {
            modelValue: dateTitle.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dateTitle).value = $event)),
            placeholder: "选择开始时间 - 结束时间",
            readonly: "",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (show.value = true))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_calendar, {
            ref_key: "calendarRef",
            ref: calendarRef,
            show: show.value,
            "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((show).value = $event)),
            "default-date": null,
            "allow-same-day": true,
            title: "",
            type: "range",
            "max-date": new Date(),
            "min-date": new Date(2019, 7, 1),
            color: "#fe7001",
            onConfirm: onConfirmDate,
            onOpen: calendarOpen
          }, null, 8, ["show", "max-date", "min-date"]),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    (curIndex.value === 1)
      ? (_openBlock(), _createBlock(Warning, {
          key: 2,
          storeNo: result.value,
          date: dateTitle.value,
          start: startTime.value,
          end: endTime.value
        }, null, 8, ["storeNo", "date", "start", "end"]))
      : _createCommentVNode("", true),
    (curIndex.value === 2)
      ? (_openBlock(), _createBlock(Monitor, {
          key: 3,
          storeNo: result.value,
          onHandle: handleMonitor
        }, null, 8, ["storeNo"]))
      : _createCommentVNode("", true),
    (curIndex.value === 3)
      ? (_openBlock(), _createBlock(DataBoard, {
          key: 4,
          data: data.value,
          start: startTime.value,
          end: endTime.value,
          isShop: true
        }, null, 8, ["data", "start", "end"]))
      : _createCommentVNode("", true),
    (curIndex.value === 4)
      ? (_openBlock(), _createBlock(DataTable, {
          key: 5,
          "time-type": 0,
          shopNo: result.value
        }, null, 8, ["shopNo"]))
      : _createCommentVNode("", true)
  ]))
}
}

})